import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
} from '@mui/material';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import { useNavigate } from 'react-router-dom';

export default function LeaderboardDashboardCard({ compact = false }) {
  const navigate = useNavigate();

  return (
    <Card
      sx={{
        mb: compact ? 2 : 3,
        color: 'white',
        background: 'linear-gradient(135deg, #F59E0B 0%, #D97706 55%, #B45309 100%)',
        boxShadow: '0 10px 30px rgba(245, 158, 11, 0.35)',
        borderRadius: 3,
        cursor: 'pointer',
        transition: 'transform 0.2s, box-shadow 0.2s',
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: '0 14px 36px rgba(245, 158, 11, 0.45)',
        },
      }}
      onClick={() => navigate('/student/leaderboard')}
    >
      <CardContent sx={{ p: compact ? 2 : 3 }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 2,
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: 1 }}>
            <Box
              sx={{
                width: 56,
                height: 56,
                borderRadius: 2,
                bgcolor: 'rgba(255,255,255,0.2)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <EmojiEventsIcon sx={{ fontSize: 32 }} />
            </Box>
            <Box>
              <Typography variant={compact ? 'subtitle1' : 'h6'} fontWeight="bold" gutterBottom>
                🏆 LMS Leaderboard
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.92, maxWidth: 520 }}>
                See who&apos;s leading in videos, quizzes, games & hands-on — set your goal and climb up!
              </Typography>
            </Box>
          </Box>
          <Button
            variant="contained"
            size={compact ? 'medium' : 'large'}
            startIcon={<TrendingUpIcon />}
            onClick={(e) => {
              e.stopPropagation();
              navigate('/student/leaderboard');
            }}
            sx={{
              bgcolor: 'white',
              color: '#B45309',
              fontWeight: 700,
              whiteSpace: 'nowrap',
              '&:hover': { bgcolor: '#fff8eb' },
            }}
          >
            View Rankings
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
}
